import { render, staticRenderFns } from "./hwVideo.vue?vue&type=template&id=1e19f663&scoped=true"
import script from "./hwVideo.vue?vue&type=script&lang=js"
export * from "./hwVideo.vue?vue&type=script&lang=js"
import style0 from "./hwVideo.vue?vue&type=style&index=0&id=1e19f663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e19f663",
  null
  
)

export default component.exports